<template>
	<div style="flex: 1; display: flex; flex-direction: column">
		<div class="device-mobile" v-if="isMobile" style="flex: 1; background: #f5f5f5">
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent />
						<span @click="toTopImg()">首页</span>
						<template v-if="viewInfo.businessTitle">
							<span class="arrow">></span>
							<span @click="barClick(0)">{{ viewInfo.businessTitle }}</span>
						</template>
						<span class="arrow">></span>
						<span >{{ viewInfo.title }}</span>
					</div>
				</div>
				<div class="main">
					<div class="rich-container" v-html="formatRichText(viewInfo.content)"></div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent />
						<span @click="toTopImg()" style="cursor: pointer">首页</span>
						<template v-if="viewInfo.businessTitle">
							<span style="color: black">></span>
							<span @click="barClick(0)">{{ viewInfo.businessTitle }}</span>
						</template>
						<span style="color: black">></span>
						<span>{{ viewInfo.title }}</span>
					</div>
				</div>
				<div class="main">
					<div class="rich-container" v-html="formatRichText(viewInfo.content)"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { menu, contentPage, flipping } from '../api/api';
export default {
	name: 'aboutUsTemplate',
	data() {
		return {
			list: [], //二级菜单数组
			parentId: this.$route.query.parentId || '', //二级菜单数组id
			count: 0,
			newsList: [],
			type: 0,
			pageNum: 1,
			// pageSize: 5,
			pageSize: 10,
			total: 0,
			menuId: '',
			newsId: '',
			contentDetails: '', //详情
			search: '',
			title: '',
			createTime: '',
			flippingList: [],
			viewInfo: {}
		};
	},
	created() {
		if (this.$route.query.viewInfo) {
			this.viewInfo = this.$route.query.viewInfo;
			sessionStorage.setItem('viewInfo', JSON.stringify(this.viewInfo));
		}
		this.getList(); // 获取二级菜单数组
	},
	mounted() {
		if (this.isMobile) {
			this.$bus.$on('reachBottom', (data) => {
				if (this.type == 0) {
					if (this.newsList.length && this.pageNum * this.pageSize < this.total) {
						this.pageNum++;
						this.getContentPage();
					} else {
						this.$message({
							message: '没有更多了~',
							center: true,
							offset: window.screen.height / 2
						});
					}
				}
			});
		}
	},
	beforeDestroy() {
		this.$bus.$off('reachBottom');
	},
	watch: {
		$route(to, from) {
			this.count = to.query.num;
			this.barClick(to.query.num);
		}
	},
	methods: {
		getSimpleText(html) {
			const re1 = new RegExp('<.+?>', 'g'); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
			const arrEntities = {
				lt: '<',
				gt: '>',
				nbsp: ' ',
				amp: '&',
				quot: '"',
				ldquo: '“',
				mdash: '—',
				rdquo: '”'
			};
			return html.replace(re1, '').replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function (all, t) {
				return arrEntities[t];
			});
		},
		//二级菜单数组
		getList() {
			menu(this.parentId).then((res) => {
				this.list = res.data;
				if (this.$route.query.num) {
					if (this.$route.query.search) {
						this.search = this.$route.query.search;
					}
					this.count = this.$route.query.num;
					this.menuId = this.list[this.$route.query.num].menuId;
					this.getContentPage();
				} else {
					this.menuId = this.list[0].menuId;
					this.getContentPage();
				}
			});
		},
		getContentPage() {
			contentPage(this.pageNum, this.pageSize, this.menuId, this.search, 1).then((res) => {
				if (!this.isMobile) {
					this.newsList = res.data;
				} else {
					if (this.pageNum == 1) {
						this.newsList = res.data;
					} else {
						this.newsList = this.newsList.concat(res.data);
					}
				}
				this.total = res.total;
				if (this.search && this.search.length > 0) {
					const reg = `/${this.search}/g`;
					this.newsList.forEach((item) => {
						console.log(item, 'item.contentTitle');
						item.contentTitle = item.contentTitle.replace(eval(reg), "<span style='color: red;'>" + this.search + '</span>');
						if (item.contentDetails) {
							item.contentDetails = this.clearBlank(this.getSimpleText(item.contentDetails));
							item.contentDetails = item.contentDetails.replace(eval(reg), "<span style='color: red;'>" + this.search + '</span>');
						}
					});
				}
				if (this.$route.query.contentId) {
					this.type = 1;
					this.newsList.forEach((item) => {
						if (item.id == this.$route.query.contentId) {
							this.contentDetails = item.contentDetails;
							this.title = item.contentTitle;
							this.createTime = item.createTime;
						}
					});
					this.$route.query.contentId = '';
				}
				// this.snckData = res.data
			});
		},
		// barClick(index) {
		// 	this.count = index
		// 	this.search = ''
		// 	this.menuId = this.list[index].menuId
		// 	this.pageNum = 1
		// 	this.getContentPage()
		// 	this.type = 0
		// },
		barClick(index) {
			this.openUrl({
				path: '/vocational',
				query: {
					id: this.viewInfo.businessId,
					index: index
				}
			});
		},

		newsItem(item) {
			this.type = 1;
			this.newsId = item.id;
			this.getflipping();
		},
		handleCurrentChange(e) {
			this.pageNum = e;
			this.getContentPage();
			console.log(`当前页: ${e}`);
		},
		// formatRichText(html) { //控制富文本图片大小
		// 	let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
		// 		match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
		// 		// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
		// 		// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
		// 		return match;
		// 	});
		// 	newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
		// 		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
		// 			'max-width:100%;');
		// 		return match;
		// 	});
		// 	newContent = newContent.replace(/<br[^>]*\/>/gi, '');

		// 	newContent = newContent.replace(/\<img/gi,
		// 		'<img style="max-width:95%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');

		// 	return newContent;
		// },
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			});
		},
		getflipping() {
			flipping(this.menuId, this.newsId).then((res) => {
				console.log(res, 'flipping');
				this.contentDetails = res.data[1].contentDetails;
				this.title = res.data[1].contentTitle;
				this.createTime = res.data[1].createTime;
				this.flippingList = res.data;
			});
		},
		//
		upNewsClick() {
			this.newsId = this.flippingList[0].id;
			this.getflipping();
			document.documentElement.scrollTop = 0;
		},
		nextNewsClick() {
			this.newsId = this.flippingList[2].id;
			this.getflipping();
			document.documentElement.scrollTop = 0;
		}
	}
};
</script>

<style lang="scss">
.rich-container {
	p {
		margin: 0;
	}
}
</style>

<style scoped lang="scss">
.title {
	font-size: 30px;
	font-weight: bold;
	top: 10px;
	left: 10px;
}
.device-mobile {
	width: 100vw;
	background: #f5f5f5;

	.newsCenter {
		width: 9.466667rem;
		// display: flex;
		// justify-content: center;
		margin: auto;

		.navigation {
			width: 100%;

			// background: #F5F5F5;
			// padding: 0 0.333333rem;
			.navigationItem {
				display: flex;
				align-items: center;
				padding-top: 0.36rem;
				// height: 1.066667rem;
				color: #1979b7;
				font-size: 0.333333rem;

				.arrow {
					color: #030303;
					margin: 0 0.133333rem;
				}

				img {
					width: 0.333333rem;
					height: 0.333333rem;
					margin-right: 0.133333rem;
				}
			}
		}
		
		.main {
			.rich-container {
				font-size: 0.426667rem;
				line-height: 2;
				text-indent: 24pt;
			}
		}
		
	}
}

.device-pc {
	.newsCenter {
		// width: 100vw;
		// display: flex;
		// justify-content: center;
		background: #f5f5f5;
		padding-bottom: 60px;
	}

	.main {
		width: 1300px;
		margin: 0 auto;
	}

	.navigation {
		// width: 1210px;
		// width: 100vw;
		background: #f5f5f5;
		display: flex;
		align-items: center;

		.navigationItem {
			width: 1300px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
			cursor: pointer;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;
		}
	}
	
	
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue